function Datetime_form_element(element) {
  this.$element = $(element);
  this.flatpickrInstance = null;

  this.selectors = {
    formParent: 'form[data-i4-decorator="Validator_form"]',
    fieldDate: '.js-field-date',
    fieldTime: '.js-field-time',
    fieldDateConverted: '.js-hidden-date-converted',
    iconDate: '.js-icon-date',
    iconTime: '.js-icon-time'
  };

  this.data = {
    timeDefault: 'time-default',
    language: 'language'
  };

  this.triggers = {
    afterLoaded: 'i4:afterLoaded',
    validate: 'i4:validate'
  };

  this.init = function () {
    this.dataTimeDefault = this.$element.data(this.data.timeDefault);
    this.dataLanguage = this.$element.data(this.data.language);

    this.$formParent = this.$element.parents(this.selectors.formParent);
    this.$fieldDate = this.$element.find(this.selectors.fieldDate);
    this.$fieldTime = this.$element.find(this.selectors.fieldTime);
    this.$fieldDateConverted = this.$element.find(this.selectors.fieldDateConverted);
    this.$iconDate = this.$element.find(this.selectors.iconDate);
    this.$iconTime = this.$element.find(this.selectors.iconTime);

    this.$fieldDate.on('blur', this.$onChangeDate.bind(this));
    this.$fieldTime.on('blur', this.$onChangeTime.bind(this));
    this.$iconDate.on('click', this.$onClickIconDate.bind(this));
    this.$iconTime.on('click', this.$onClickIconTime.bind(this));

    if (this.$fieldTime.val() != this.dataTimeDefault) {
      this.$fieldTime.show();
    } else {
      this.$fieldTime.hide();
    }

    this.$formParent.on(this.triggers.afterLoaded, (function () {
      var dateConverted = this.convert_date(this.$fieldDateConverted.val());
      this.$fieldDate.val(dateConverted);
      this.$fieldDate.trigger(this.triggers.validate);

      // https://flatpickr.js.org/options/
      this.flatpickrInstance = this.$fieldDate.flatpickr({
        dateFormat: 'd.m.Y',
        allowInput: true,
        clickOpens: false,
        locale: this.dataLanguage,
        weekNumbers: true,
      });
    }).bind(this));
  };

  this.$onChangeDate = function (event) {
    if (!this.$fieldDate.hasClass('invalid')) {
      this.convertDate();
      this.flatpickrInstance.setDate(this.$fieldDate.val());
    }
  };

  this.$onChangeTime = function (event) {
    if (!this.$fieldTime.hasClass('invalid')) {
      this.convertDate();
    }
  };

  this.$onClickIconTime = function (event) {
    event.preventDefault();

    if (this.$fieldTime.is(':visible')) {
      this.$fieldTime.hide();
      this.$fieldTime.val(this.dataTimeDefault);
      this.convertDate();
    } else {
      this.$fieldTime.show();
      this.$fieldTime.focus();
    }
  };

  this.$onClickIconDate = function (event) {
    event.preventDefault();

    if (this.flatpickrInstance) {
      this.flatpickrInstance.toggle();
    }
  };

  this.convertDate = function () {
    if (this.$fieldDate.val() === '') {
      this.$fieldDateConverted.val('');
    } else {
      var date = this.convert_date(this.$fieldDate.val());
      var time = '';

      if (date != '' && this.$fieldTime.length && this.$fieldTime.val() != '') {
        time = ' ' + this.$fieldTime.val();
      }

      if (date != '' && time == '') {
        time = ' ' + this.dataTimeDefault;
      }

      this.$fieldDateConverted.val(date + time);
    }
  };

  /**
   * Ex function Calendar.convert_date() in deleted file i4_datepicker.js
   */
  this.convert_date = function (date) {
    var result = '';
    var splitted_time = date.split(" ");

    if (splitted_time.length == 2) {
      date = splitted_time[0];
    }

    var splitted_en = date.split("-");
    var splitted_de = date.split(".");

    if (splitted_en.length == 3 && splitted_en[0].length == 4 && (splitted_en[1].length > 0 && splitted_en[1].length < 3) && (splitted_en[2].length > 0 && splitted_en[2].length < 3)) {
      result = splitted_en[2] + '.' + splitted_en[1] + '.' + splitted_en[0];
    } else if (splitted_de.length == 3 && (splitted_de[0].length > 0 && splitted_de[0].length < 3) && (splitted_de[1].length > 0 && splitted_de[1].length < 3) && splitted_de[2].length == 4) {
      result = splitted_de[2] + '-' + splitted_de[1] + '-' + splitted_de[0];
    }

    return result;
  };
}
